import { render } from "./wError.vue?vue&type=template&id=2585f5ab&ts=true"
import script from "./wError.vue?vue&type=script&lang=ts"
export * from "./wError.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__